/**
 * Normalize English criteria body for draft save (matches DB LOWER on criteria_body.en).
 * Gated by LaunchDarkly `idea-MDP-452` at call sites.
 * @param {unknown} value
 * @returns {string}
 */
export function normalizeCriteriaBodyEn(value) {
  if (value == null) return "";
  return String(value).toLowerCase();
}

/**
 * @param {unknown} value
 * @param {boolean} enabled When false, returns value unchanged (aside from nullish → "").
 * @returns {string}
 */
export function maybeNormalizeCriteriaBodyEn(value, enabled) {
  if (!enabled) {
    if (value == null) return "";
    return String(value);
  }
  return normalizeCriteriaBodyEn(value);
}
